import axios from "./ServicesConfig";

const atendimentosService = {
  async salvarAtendimento(data) {
    return await axios.post("/atendimentos", data);
  },
};
export default atendimentosService;
